import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./Subscription.scss";
import AddCard from "./component/AddCard";
import SubscriptionCard from "./component/SubscriptionCard";
import candleBg from "../../../Assets/images/candleBg.png";
import { updateToken } from "helpers/api_helper";
import { useFetchRecommendedPlansQuery, useFetchSubscriptionPlansQuery, useFetchProductDetailsQuery, useFetchUserProfileQuery, useCreateCheckoutSessionMutation, useOpenBillingPortalMutation, useBillingPortalMutation, useBillingPortalSwitchPlanMutation } from "store/services/user.service";
import Loader from "components/shared/Loader";

const SubscriptionBuy = () => {
  const token = useSelector((state) => state.auth.token);
  const { data: subscriptionData = [], isLoading } =
    useFetchSubscriptionPlansQuery(token);
  const { data: recommendedPlans, isLoading: recommendedPlansLoading, isError } = useFetchRecommendedPlansQuery();
  const {
    data: currentPlan,
    error: planError,
    isLoading: planLoading,
  } = useFetchProductDetailsQuery();
  const [selectedPlan, setSelectedPlan] = useState(null);

  // get user profile
  const { data: userProfile, isLoading: userProfileLoading } = useFetchUserProfileQuery();

  // create checkout session
  const [createCheckoutSession, { isLoading: checkoutSessionLoading }] = useCreateCheckoutSessionMutation();

  // open stripe billing portal with update plan link
  const [openBillingPortal, { isLoading: billingPortalLoading }] = useBillingPortalSwitchPlanMutation();

  useEffect(() => {
    if (token) {
      updateToken(token);
    }
  }, [token]);

  const handleClickBuy = async (plan) => {
    try {
      setSelectedPlan(plan._id);
      let url = null;
      if(userProfile?.isSubscribed) {
        const response = await openBillingPortal({
          planId: plan._id,
        }).unwrap();  
        url = response?.data?.url;
      } else {
        const response = await createCheckoutSession(
          plan._id
        ).unwrap();
        url = response?.url;
      }
      setSelectedPlan(null);

      if (!url) {
        throw new Error("Invalid response");
      }

      window.location.href = url;
    } catch (error) {
      setSelectedPlan(null);
      console.error("Error creating checkout session:", error);
    }
  }

  return (
    <section
      className="subscription py-5 position-relative"
      style={{
        backgroundImage: `url(${candleBg})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        zIndex: 9,
      }}
    >
      <Container>
        <Row>
          <Col lg="12" className="my-5">
            {recommendedPlans?.length > 0 && (
              <div className="my-5 recommended-plans">
                <h2 class="section-title text-center my-2 text-uppercase">Recommended Plans</h2>
                <Row className="justify-content-center mt-4">
                  {recommendedPlans.map((plan, index) => (
                    <Col lg="4" sm="6" key={plan.planId?._id} className="mb-4">
                      <div className="SubscriptionCard h-100 position-relative">
                        <SubscriptionCard
                          plan={plan?.planId}
                          isExpired={index === 0}
                          handleBuyNow={handleClickBuy}
                          isCurrent={currentPlan?.planId ? currentPlan?.planId === plan.planId?._id : false}
                          isLoading={selectedPlan === plan.planId?._id && (checkoutSessionLoading || billingPortalLoading)}
                          isSubscribed={userProfile?.isSubscribed}
                        />
                        {/* {index === 1 && (
                          <AddCard addCard={addCard} setAddCard={setAddCard} />
                        )} */}
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}
            <Row className="justify-content-center mt-4">
              {isLoading || userProfileLoading ? (
                <div className="fixed-loader">
                  <Loader />
                </div>
              ) : (
                subscriptionData.map((plan, index) => (
                  <Col lg="4" sm="6" key={plan._id} className="mb-4">
                    <div className="SubscriptionCard h-100 position-relative">
                      <SubscriptionCard
                        plan={plan}
                        isExpired={index === 0}
                        handleBuyNow={handleClickBuy}
                        isCurrent={currentPlan?.planId ? currentPlan?.planId === plan._id : false}
                        isLoading={selectedPlan === plan._id && (checkoutSessionLoading || billingPortalLoading)}
                        isSubscribed={userProfile?.isSubscribed}
                      />
                      {/* {index === 1 && (
                        <AddCard addCard={addCard} setAddCard={setAddCard} />
                      )} */}
                    </div>
                  </Col>
                ))
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SubscriptionBuy;
